export default {
      id: "returningTruckSatellite-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons.svg#returningTruckSatellite",
      toString: function () {
        return this.url;
      }
    }